import { createRequiredContext } from '../createRequiredContext';
const { useContext, Provider, Context, Consumer } = createRequiredContext('HttpClientProvider');
export const HttpClientProvider = Provider;
export const HttpClientConsumer = Consumer;
export const HttpClientContext = Context;
export const useHttpClient = useContext;
//# sourceMappingURL=HttpClientProvider.js.map